import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { toFaaReportOptions } from '../utils/report-wire-utils';
import { nullableNumber, nullableString } from '../utils/wire-value-utils';
import { FaaReportOptions } from './faa-report-options.model';
import { FaaReportStatus } from './faa-report-status.model';
import { FaaReportType } from './faa-report-type.model';

/**
 * An FAA report as `/admin/faa-reports` returns it (hub `data-models/faa-report.ts`). Only the dates are
 * writable (PUT /admin/faa-reports/:id); everything else is set by generation. A value the hub didn't send
 * stays `undefined`.
 */
export class FaaReport extends Base {
  // Writable via PUT /admin/faa-reports/:id (YYYY-MM-DD, as sent)
  startDate?: string | null;
  endDate?: string | null;

  // Read-only
  organizationId?: string | null;
  /** Not sent by the hub today; the page falls back to the org picker's names. */
  organizationName?: string | null;
  name?: string | null;
  reportType?: FaaReportType | null;
  status?: FaaReportStatus | null;
  options?: FaaReportOptions;
  generationProgress?: number | null;
  recordCount?: number | null;
  fileSize?: string | null;
  reportUrl?: string | null;
  /** Pre-signed download URL; only on the detail of a ready or submitted report. */
  downloadUrl?: string | null;
  submittedAt?: string | null;
  submittedTo?: string | null;
  errorMessage?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.startDate = nullableString(source['startDate']);
    this.endDate = nullableString(source['endDate']);
    this.organizationId = nullableString(source['organizationId']);
    this.organizationName = nullableString(source['organizationName']);
    this.name = nullableString(source['name']);
    this.reportType = nullableString(source['reportType']) as FaaReportType | null | undefined;
    this.status = nullableString(source['status']) as FaaReportStatus | null | undefined;
    this.options = toFaaReportOptions(source['options']);
    this.generationProgress = nullableNumber(source['generationProgress']);
    this.recordCount = nullableNumber(source['recordCount']);
    this.fileSize = nullableString(source['fileSize']);
    this.reportUrl = nullableString(source['reportUrl']);
    this.downloadUrl = nullableString(source['downloadUrl']);
    this.submittedAt = nullableString(source['submittedAt']);
    this.submittedTo = nullableString(source['submittedTo']);
    this.errorMessage = nullableString(source['errorMessage']);
  }
}
